import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import classnames from "classnames";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./pdp-unique-material-tile.scss";

const PDPUniqueMaterialTile = ({
  centerImage,
  isActive,
  isUnallowed,
  uniqueMaterial,
  title,
  tag,

  imageType,
  materialDisplayName,
  configurationId,
  materialId,

  item,
  itemClickHandler,

  alt,
  imgUrl,
  scrollPosition = null,
  visibleByDefault = false

}) => {
  const { t } = useTranslation();
  const texts = {
    notCombinable: t("FritzHansen_Project_ConsumersAndProfessionals_PDP_NotCombinable"),
  };
  const [imageLoadError,setImageLoadError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [loadingError, setLoadingError] = useState(false);

  const loadedHandler = () => {
    setImageLoaded(true);
 //   if (onSuccessHandler) onSuccessHandler();
  };
  const css = classnames({
    "product-image": true,
    "product-image--reveal": imageLoaded,
    "product-image--error": loadingError,
  });

  const classList = classnames({
    "pdp-swatch-tile": true,
    "pdp-swatch-tile--cover": !centerImage && !imageLoadError,
    "is-active": isActive,
    "is-unallowed": isUnallowed,
    "is-animated": title?.length > 18,
    "no-image": imageLoadError
  });

  const onError = () => {
    setImageLoadError(true);
  };

  return (
    <button className={classList} onClick={() => itemClickHandler(item, isUnallowed, uniqueMaterial)}>
      <div className="pdp-swatch-tile__inner">
      <figure className={css}>
      <LazyLoadImage
        className="product-image__image"
        onError={onError}
        alt={alt}
        src={imgUrl} // use normal <img> attributes as props
        effect="opacity"
        afterLoad={loadedHandler}
        scrollPosition={scrollPosition}
        visibleByDefault={visibleByDefault}

      />
    </figure>
        {/* <ProductImage type={imageType} im={materialId || configurationId || ""} alt={title} onErrorHandler={onError} useLargeFallback={true}/> */}
        {tag && <span className="pdp-swatch-tile__tag">{tag}</span>}
        {isUnallowed && <span className="pdp-swatch-tile__message">{texts.notCombinable}</span>}
      </div>
      <h6>
        <span>{title}</span>
      </h6>
    </button>
  );
};
PDPUniqueMaterialTile.propTypes = {
  centerImage: PropTypes.bool,
  isActive: PropTypes.bool,
  isUnallowed: PropTypes.bool,
  title: PropTypes.string,
  tag: PropTypes.string,
  item: PropTypes.object.isRequired,
  itemClickHandler: PropTypes.func.isRequired,
};

export default PDPUniqueMaterialTile;
